import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Grid,
  Button,
} from '@material-ui/core';
import { DatabaseContext } from '../../contexts/DatabaseContext';
import { UserContext } from '../../contexts/UserContext';
import { useSnackbar } from 'notistack';
import Axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const CardOrderReports = () => {
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();
  const { siteCode } = Site;
  const { RptCardsOrdered, setRptCardsOrdered } = useState(false);
  const [reportType, setReportType] = useState('');
  const [cardsThisMonth, setCardsThisMonth] = useState(false);
  const [cards30Days, setCards30Days] = useState(false);
  const [cards60Days, setCards60Days] = useState(false);
  const [cards90Days, setCards90Days] = useState(false);

  const handleReportTypeChange = (id) => {
    switch (id) {
      case 'ckbThisMonth': {
        setCardsThisMonth(true);
        setCards30Days(false);
        setCards60Days(false);
        setCards90Days(false);
        setReportType('ThisMonth');
        break;
      }
      case 'ckb30Days': {
        setCardsThisMonth(false);
        setCards30Days(true);
        setCards60Days(false);
        setCards90Days(false);
        setReportType('30Days');
        break;
      }
      case 'ckb60Days': {
        setCardsThisMonth(false);
        setCards30Days(false);
        setCards60Days(true);
        setCards90Days(false);
        setReportType('60Days');
        break;
      }
      case 'ckb90Days': {
        setCardsThisMonth(false);
        setCards30Days(false);
        setCards60Days(false);
        setCards90Days(true);
        setReportType('90Days');
        break;
      }
      default:
        break;
    }
  };

  const runCardOrdersReport = async () => {
    try {
      const res = await Axios.get(
        `${apiUrl}/api/reports/card/?siteCode=${siteCode}&reporttype=${reportType}`
      );
      if (res.data.success) {
        if (res.data.data[0].length > 0) {
          CardsReportPDF(res.data.data[0]);
        } else {
          enqueueSnackbar('No Report Data Found', {
            variant: 'error',
            autoHideDuration: 6000,
          });
        }
      }
    } catch (err) {
      enqueueSnackbar(err.response.data.error, {
        variant: 'error',
        autoHideDuration: 6000,
      });
    }
  };

  const CardsReportPDF = async (reportData) => {
    console.log(Site);
    const unit = 'pt';
    const size = 'A4'; // Use A1, A2, A3 or A4
    const orientation = 'portrait'; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(12);

    switch (reportType) {
    }

    const title = Site.name + ' - Cards Ordered Report';
    const headers = [
      [
        'Order ID',
        'Display Name',
        'External ID',
        'Ordered By',
        'Date/Time Ordered',
      ],
    ];

    //var re = allPatrons;

    const data = reportData.map((re) => [
      re.OrderID,
      re.firstName + ' ' + re.lastName,
      re.externalID,
      re.displayName,
      re.dateCreated,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
      columnStyles: {
        0: { cellWidth: 60 },
        1: { cellWidth: 125 },
        2: { cellWidth: 100 },
        3: { cellWidth: 125 },
        4: { cellWidth: 105 },
      },
      tableLineColor: [0, 0, 0],
      tableLineWidth: 1,
      bodyStyles: {
        lineWidth: 0.2,
        lineColor: [73, 138, 159],
      },
    };
    var today = new Date().toLocaleString();

    doc.setProperties({
      title: Site.name + ' - Cards Ordered Report',
      subject: Site.name + ' - Cards Ordered Report',
      author: Site.name,
      keywords: Site.name,
      creator: 'IDCapture - ' + Site.name,
    });

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save(today + ' Patron Data Report.pdf');
  };

  return (
    <Container>
      <div>
        <Checkboxes>
          <FormControlLabel
            control={
              <Checkbox
                name='ckbThisMonth'
                onChange={(e) => {
                  handleReportTypeChange(e.target.name);
                }}
                checked={cardsThisMonth}
              />
            }
            label='Cards Ordered This Month'
          />
          <FormControlLabel
            control={
              <Checkbox
                name='ckb30Days'
                onChange={(e) => {
                  handleReportTypeChange(e.target.name);
                }}
                checked={cards30Days}
              />
            }
            label='Cards Ordered Last 30 Days'
          />

          <FormControlLabel
            control={
              <Checkbox
                name='ckb60Days'
                onChange={(e) => {
                  handleReportTypeChange(e.target.name);
                }}
                checked={cards60Days}
              />
            }
            label='Cards Ordered Last 60 Days'
          />
          <FormControlLabel
            control={
              <Checkbox
                name='ckb90Days'
                onChange={(e) => {
                  handleReportTypeChange(e.target.name);
                }}
                checked={cards90Days}
              />
            }
            label='Cards Ordered Last 90 Days'
          />
        </Checkboxes>
        <Actions>
          <Button onClick={runCardOrdersReport} colour='success'>
            Run Report
          </Button>
        </Actions>
      </div>
    </Container>
  );
};

const Container = styled.div``;

const Iconstyles = {
  fontSize: '17px',
};

const CheckboxWithTextField = styled.div`
  display: flex;
  align-items: center;
`;

const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.1rem;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1rem;
  margin-right: 2rem;
`;

export default CardOrderReports;
